<template>
  <div class="activity-notice-bar">
    <van-notice-bar left-icon="volume-o" mode="closeable" :scrollable="false" v-if="rolePower && isShowActivityTips">
      <div class="notice-text" @click="goNewActivity">
        <div class="tips-text-left">您当前有待参与的学术活动</div>
        <div class="tips-text-right">去查看</div>
      </div>
    </van-notice-bar>
  </div>
</template>

<script>
import { BOOL_GOAL, BOOL_NON_EP, BOOL_SENIOR, BOOL_SENIOR_EMPLOYEE } from '@/utils/configRoles'
import { getActivityList } from '@/api/api'
export default {
  name: 'ActivityNoticeBar',
  data() {
    return {
      isShowActivityTips: false
    }
  },
  computed: {
    // 是否为目标EP术者 非目标EP术者 大主任 或者 大主任兼学员
    rolePower() {
      return BOOL_GOAL || BOOL_NON_EP || BOOL_SENIOR || BOOL_SENIOR_EMPLOYEE
    },
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    getData() {
      let params = {}
      // params = {
      //   hospitalId: this.userInfo.hospitalId || '',
      //   iepUserId: this.userInfo.id,
      //   queryAll: 'Y',
      //   activityStatusSign: 'Y'
      // }
      // 大主任或者大主任兼学员
      if (BOOL_SENIOR || BOOL_SENIOR_EMPLOYEE) {
        params = {
          hospitalId: this.userInfo.hospitalId || '',
          iepUserId: this.userInfo.id,
          queryAll: 'Y',
          activityStatusSign: 'Y'
        }
        // 目标EP术者 或 非目标EP术者
      } else if (BOOL_GOAL || BOOL_NON_EP) {
        params = {
          iepUserId: this.userInfo.id,
          queryAll: 'Y',
          activityStatusSign: 'Y'
        }
      } else {
        return
      }
      getActivityList(params)
        .then(res => {
          console.log('getActivityList res', res)
          if (res && res.data) {
            console.log('getActivityList res.data.list.length', res.data.list.length)
            if (res.data.list && res.data.list.length > 0) {
              this.isShowActivityTips = true
            } else {
              this.isShowActivityTips = false
            }
          } else {
            this.isShowActivityTips = false
          }
        })
        .catch(err => {
          this.isShowActivityTips = false
          console.log('getActivityList err', err)
        })
    },
    goNewActivity() {
      this.$router.push({
        path: '/train',
        query: { activityStatusSign: 'Y' }
      })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
.activity-notice-bar {
  width: 100%;
  margin-top: -9px;
}
/deep/ .notice-text {
  display: flex;
  line-height: 19px;
  height: 17px;
  .tips-text-right {
    margin-left: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/ActivityNoticeBar.vue